import React, { Component } from "react";
import axios from "axios";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import classnames from "classnames";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  InputBoxComponent,
  NewInputText,
  TextAreaReusableComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { RestaurantMapSetupValidation } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantMapSetupValidation";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import {
  InputCharacterCheck,
  InputCharNumFunc,
} from "../../../../function/InputCharNumCheckFunc";
//import { serverApi } from "../../../../config/Keys";
import isEmpty from "../../../../store/validation/is-Empty";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { TimeZoneCustom } from "../../../vendorOnboradingComponents/allScreens/restaurantDetailsOnboarding/TimeZoneCustom";
import { CurrencyPicker } from "../../../vendorOnboradingComponents/allScreens/restaurantDetailsOnboarding/CurrencyPicker";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
// import { serverApi } from "../../../../config/Keys";
import {
  getAllStateFromCountry,
  getAllCountries,
  getAllCityFromState,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Media from "react-media";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export class VendorRestaurantDetailsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      changesText: false,
      hasSetMapProps: false,
      loader: false,
      google_place_id: "",
      name: "",
      address: "",
      city: "",
      area: "",
      pinCode: "",
      businessState: "",
      location: {
        type: "Point",
        coordinates: ["", ""],
      },
      country_code: "",
      contact_detail: [{ country_code: "", mobile_no: "" }],
      enquiry_email: [""],
      emailError: "",
      phoneError: "",
      country: "",
      currency: "",
      timezone: "",
      errors: {},
      error: null,
      isLoading: false,
      data: { country: "", state: "", city: "" },
      countries: [],
      states: [],
      cities: [],
    };
  }
  

  async componentDidMount() {
    this.props.getAllCountries(this.onSuccessGetAllCountries);
    // if (this.props.auth.loader) {
    //   this.setState({
    //     loader: this.props.auth.loader,
    //   });
    // }
    if (this.props.onboarding._id) {
      this.setState({
        google_place_id: !isEmpty(this.props.onboarding.google_place_id)
          ? this.props.onboarding.google_place_id
          : "",
        address: !isEmpty(this.props.onboarding.restaurant_address)
          ? this.props.onboarding.restaurant_address
          : "",
        city: !isEmpty(this.props.onboarding.city)
          ? this.props.onboarding.city
          : "",
        area: !isEmpty(this.props.onboarding.area)
          ? this.props.onboarding.area
          : "",
        pinCode: !isEmpty(this.props.onboarding.pinCode)
          ? this.props.onboarding.pinCode
          : "",
        businessState: !isEmpty(this.props?.onboarding?.state)
          ? this.props?.onboarding?.state
          : "",
        location:
          !isEmpty(this.props.onboarding.location) &&
          !isEmpty(this.props.onboarding.location.coordinates)
            ? {
                coordinates: [
                  this.props.onboarding.location.coordinates[1],
                  this.props.onboarding.location.coordinates[0],
                ],
              }
            : { coordinates: ["", ""] },
        page_completed_till: 1,

        name: !isEmpty(this.props.onboarding.restaurant_name)
          ? this.props.onboarding.restaurant_name
          : "",
        enquiry_email: !isEmpty(this.props.onboarding.enquiry_email)
          ? this.props.onboarding.enquiry_email
          : [""],
        contact_detail: !isEmpty(this.props.onboarding.contact_detail)
          ? this.props.onboarding.contact_detail
          : [{ country_code: "", mobile_no: "" }],
        country: !isEmpty(this.props.onboarding.country)
          ? this.props.onboarding.country
          : "",
        currency: !isEmpty(this.props.onboarding.currency)
          ? this.props.onboarding.currency
          : "",
        timezone: !isEmpty(this.props.onboarding.timezone)
          ? this.props.onboarding.timezone
          : "",
      });
  
    }

    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        //console.log(result.data)
        this.setState({
          country_code: result.data.country_calling_code,
          // country: result.data.country_name,
          currency: result.data.currency,
          timezone: result.data.timezone,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );

    if (
      this.props.location.state !== null &&
      this.props.location.state !== undefined
    ) {
      if (
        !isEmpty(this.props.location.state.formData.data) !==
          this.state.secondScreen &&
        !isEmpty(this.props.location.state.formData.actionButton) !==
          this.state.actionButton
      ) {
        this.setState({
          secondScreen: this.props.location.state.formData.data,
          actionButton: this.props.location.state.formData.actionButton,
        });
      }
    }
  }

 

  onSuccessGetAllCountries = (allData) => {
    this.setState({ countries: allData });
  };

  componentDidUpdate() {
    if (isEmpty(this.state.currency) || isEmpty(this.state.timezone)) {
      axios.get("https://ipapi.co/json").then((result) =>
        //console.log(result.data)
        this.setState({
          country_code: result.data.country_calling_code,
          // country: result.data.country_name,
          currency: result.data.currency,
          timezone: result.data.timezone,
          isLoading: false,
        })
      );
    }
   
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      nextProps.onboarding._id &&
      nextProps.auth.user.VendorUser &&
      !isEmpty(nextProps.onboarding.location) &&
      !isEmpty(nextProps.onboarding.location.coordinates)
    ) {
      if (
        (!isEmpty(nextProps.onboarding.location) &&
          !isEmpty(nextProps.onboarding.location.coordinates[1]) &&
          !isEmpty(nextProps.onboarding.location.coordinates[0]) &&
          !isEmpty(nextProps.auth.user.VendorUser.country_code) &&
          !nextState.hasSetMapProps) ||
        nextState.location.coordinates[0] !==
          nextProps.onboarding.location.coordinates[1] ||
        nextState.location.coordinates[1] !==
          nextProps.onboarding.location.coordinates[0]
      ) {
        return {
          google_place_id: !isEmpty(nextProps.onboarding.google_place_id)
            ? nextProps.onboarding.google_place_id
            : "",
          address: !isEmpty(nextProps.onboarding.restaurant_address)
            ? nextProps.onboarding.restaurant_address
            : "",
          city: !isEmpty(nextProps.onboarding.city)
            ? nextProps.onboarding.city
            : "",
          area: !isEmpty(nextProps.onboarding.area)
            ? nextProps.onboarding.area
            : "",
          pinCode: !isEmpty(nextProps.onboarding.pinCode)
            ? nextProps.onboarding.pinCode
            : "",
          businessState: !isEmpty(nextProps.onboarding.businessState)
            ? nextProps?.onboarding?.businessState
            : "",
          location:
            !isEmpty(nextProps.onboarding.location) &&
            !isEmpty(nextProps.onboarding.location.coordinates)
              ? {
                  coordinates: [
                    nextProps.onboarding.location.coordinates[1],
                    nextProps.onboarding.location.coordinates[0],
                  ],
                }
              : { coordinates: ["", ""] },
          // location: !isEmpty(nextProps.onboarding.location)
          //   ? nextProps.onboarding.location
          //   : { latitude: "", longitude: "" },
          page_completed_till: 1,

          name: !isEmpty(nextProps.onboarding.restaurant_name)
            ? nextProps.onboarding.restaurant_name
            : "",
          enquiry_email: !isEmpty(nextProps.onboarding.enquiry_email)
            ? nextProps.onboarding.enquiry_email
            : [""],
          contact_detail: !isEmpty(nextProps.onboarding.contact_detail)
            ? nextProps.onboarding.contact_detail
            : [{ country_code: "", mobile_no: "" }],
          country: !isEmpty(nextProps.onboarding.country)
            ? nextProps.onboarding.country
            : "",
          currency: !isEmpty(nextProps.onboarding.currency)
            ? nextProps.onboarding.currency
            : "",
          timezone: !isEmpty(nextProps.onboarding.timezone)
            ? nextProps.onboarding.timezone
            : "",
          hasSetMapProps: true,
        };
      }
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextState.errors,
      };
    }
    return null;
  }

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({
      country_code: "+" + value,
      actionButton: 3,
      changesText: true,
    });
  };

  handleChange = (countryTimeZone) => {
    this.setState({
      timezone: countryTimeZone,
      changesText: true,
    });
  };

  onChange = (e) => {
    this.props.clear_all_errors();
    this.setState({
      [e.target.name]: e.target.value,
      changesText: true,
    });
  };

  onChangePinCode = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      changesText: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      changesText: true,
    });
  };

  // county state city handlers //

  onSuccessGetAllStates = (data) => {
    this.setState({ states: data });
  };

  onSuccessGetAllCity = (data) => {
    this.setState({ cities: data });
  };

  onChangeCountryValue = (e) => {
    const { data, countries } = this.state;

    this.props.getAllStateFromCountry(
      e.target.value,
      this.onSuccessGetAllStates
    );

    this.setState({
      data: { ...data, [e.target.name]: e.target.value, state: "", city: "" },
    });

    for (let i = 0; i < countries.length; i++) {
      if (e.target.value === countries[i].id) {
        this.setState({ country: countries[i].name });
        this.setState({ businessState: "" });
        this.setState({ city: "" });
        break;
      }
    }
  };

  onChangeStateValue = (e) => {
    const { data, states } = this.state;
    const { props, onSuccessGetAllCity } = this;

    props.getAllCityFromState(e.target.value, onSuccessGetAllCity);

    this.setState({
      data: {
        country: data.country,
        [e.target.name]: e.target.value,
        city: "",
      },
    });

    for (let i = 0; i < states.length; i++) {
      if (e.target.value === states[i].id) {
        this.setState({ businessState: states[i].name });
        this.setState({ city: "" });
        break;
      }
    }
  };

  onChangeCityValue = (e) => {
    const { data, cities } = this.state;

    this.setState({
      data: {
        country: data.country,
        state: data.state,
        [e.target.name]: e.target.value,
      },
    });

    for (let i = 0; i < cities.length; i++) {
      if (e.target.value === cities[i].id) {
        this.setState({ city: cities[i].name });
        break;
      }
    }
  };

  /**************************
   * @DESC - ONCHANGE SCREEN HANDLER
   ***************************/
  onChangeScreen = (e) => {
    e.preventDefault();
    let formData = {
      id: this.props.onboarding._id,
      restaurant_name: this.state.name,
      restaurant_address: this.state.address,
      city: this.state.city,
      area: this.state.area,
      pinCode: this.state.pinCode,
      state: this.state.businessState,
      enquiry_email: this.state.enquiry_email,
      contact_detail: this.state.contact_detail,
      country: this.state.country,
      currency: this.state.currency,
      timezone: this.state.timezone,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      changesText: false,
    });
  };

  /*****************************************
   * @DESC - Multiple Email Handlers
   ******************************************/
  onEmailAddHandler = (e) => {
    e.preventDefault();
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      enquiry_email[enquiry_email.length - 1] === "" ||
      !validEmailRegex.test(enquiry_email[enquiry_email.length - 1])
    ) {
      const { errors, isValid } = RestaurantMapSetupValidation(this.state);
      errors.enquiry_email = "Email is Required";
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      }
    } else {
      enquiry_email.push("");
      this.setState({
        enquiry_email: enquiry_email,
      });
    }
  };

  onEmailChangeHandler = (index) => (e) => {
    let enquiry_email = this.state.enquiry_email;
    enquiry_email[index] = e.target.value;
    this.setState({
      enquiry_email: enquiry_email,
      emailError: "",
      errors: {},
      actionButton: 3,
      changesText: true,
    });
  };

  onEmailDeleteHandler = (index) => (e) => {
    let enquiry_email = this.state.enquiry_email;
    if (enquiry_email.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      enquiry_email.splice(index, 1);
      this.setState({
        enquiry_email: enquiry_email,
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Phone Handlers
   ******************************************/
  onPhondeAddHandler = (e) => {
    e.preventDefault();
    let contact_detail = this.state.contact_detail;
    if (contact_detail.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      contact_detail[contact_detail.length - 1].mobile_no === "" ||
      contact_detail[contact_detail.length - 1].mobile_no.length < 9
    ) {
      const { errors, isValid } = RestaurantMapSetupValidation(this.state);
      errors.mobile_no = "Phone is required";
      if (!isValid) {
        this.setState({
          errors: errors,
        });
      }
    } else {
      let obj = {
        country_code: this.state.country_code,
        mobile_no: "",
      };
      contact_detail.push(obj);
      this.setState({ contact_detail: contact_detail });
    }
  };

  onPhoneChangeHandler = (index) => (e) => {
    let contact_detail = this.state.contact_detail;
    contact_detail[index].mobile_no = e.target.value.slice(
      0,
      e.target.maxLength
    );
    this.setState({
      contact_detail: contact_detail,
      phoneError: "",
      errors: {},
      actionButton: 3,
      changesText: true,
    });
  };

  onCountryCodeChangeHandler = (index) => (e) => {
    let contact_detail = this.state.contact_detail;
    contact_detail[index].country_code = e.target.value;
    this.setState({
      contact_detail: contact_detail,
      actionButton: 3,
      changesText: true,
    });
  };

  onPhoneDeleteHandler = (index) => (e) => {
    let contact_detail = this.state.contact_detail;
    if (contact_detail.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      contact_detail.splice(index, 1);
      this.setState({ contact_detail: contact_detail });
    }
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onboarding._id) {
      let formData = {
        id: this.props.onboarding._id,
        restaurant_name: this.state.name,
        restaurant_address: this.state.address,
        city: this.state.city,
        area: this.state.area,
        pinCode: this.state.pinCode,
        state: this.state.businessState,
        enquiry_email: this.state.enquiry_email,
        contact_detail: this.state.contact_detail,
        country: this.state.country,
        currency: this.state.currency,
        timezone: this.state.timezone,
      };
      this.props.create_and_update_restaurant(formData);
      this.setState({
        changesText: false,
      });
      // this.props.history.push("/seatingdashboard");
    }
  };

  render() {
    // if (this.state.loader) {
    //   return (
    //     <React.Fragment>
    //       <AmealioLoader />
    //     </React.Fragment>
    //   );
    // }
    console.log(
      this.state.country,
      this.state.businessState,
      this.state.city,
      "country",this.state.data
    );
    const {
      editButton,
      changesText,
      errors,
      enquiry_email,
      contact_detail,
      google_place_id,
      name,
      address,
      area,
      city,
      pinCode,
      businessState,
      country,
      currency,
      timezone,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div id="onboarding-scrollbar" className="col-12 col-md-6">
                <div>
                  <div>
                    <TopTextReusableComponent
                      headingText="Business details"
                      headingParagraph="Please Enter your Business Information only some of this information is displayed to the end User"
                      displayEdit={editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <br />
                  <Form noValidate onSubmit={this.handleSubmit}>
                    <div>
                      <div className="col-12 p-0">
                        <NewInputText
                          extraClass="m-0"
                          displayLabel={true}
                          controlId="name"
                          labelText="Restaurant name*"
                          variant="outlined"
                          // showLabelSmall={true}
                          // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                          placeHolder="eg. Amealio"
                          name="name"
                          inputType="text"
                          onChange={this.onChange}
                          value={this.state.name}
                          disabled={editButton === false ? true : false}
                          required="required"
                          onFocusOut={this.onFocusOut}
                          showBottom={true}
                          helpTextDisplay={true}
                          error={errors.name}
                          inputClassName={classnames(
                            "input-component-inputfield",
                            {
                              invalid: errors.name,
                            }
                          )}
                        />
                        <div
                          className="opacity5 mt-1 mb-4"
                          style={{
                            fontSize: "12px",
                            fontFamily: "Roboto-Regular",
                            color: "#212121",
                            lineHeight: "16px",
                          }}
                        >
                          (Restaurant names on Amealio need to be written as
                          they appear on the board outside the restaurant)
                        </div>
                      </div>
                      <div className="col-12 p-0">
                        <NewInputText
                          extraClass="m-0"
                          controlId="address"
                          displayText={true}
                          labelText="Restaurant address*"
                          multiline={true}
                          labelTextClass="text-area-lable"
                          placeholder="Enter Restaurant Address*"
                          rows="4"
                          onChange={this.onChange}
                          onFocusOut={this.onFocusOut}
                          name="address"
                          value={this.state.address}
                          disabled={editButton === false ? true : false}
                          inputClassName={classnames(
                            "input-text-area text-area-new",
                            {
                              invalid: errors.address,
                            }
                          )}
                          error={errors.address}
                        />
                        <div
                          className="opacity5 mt-1 mb-4"
                          style={{
                            fontSize: "12px",
                            fontFamily: "Roboto-Regular",
                            color: "#212121",
                            lineHeight: "16px",
                          }}
                        >
                          (Restaurant Address on Amealio need to be written to
                          help users navigate to the place, please include all
                          the details )
                        </div>
                      </div>
                      <div className="col-12 p-0">
                        <div className="row">
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <NewInputText
                              displayLabel={true}
                              controlId="area"
                              labelText="Area*"
                              placeHolder="eg. Koregaon Park*"
                              name="area"
                              inputType="text"
                              onChange={this.onChange}
                              onFocusOut={this.onFocusOut}
                              onKeyDown={InputCharacterCheck}
                              value={this.state.area}
                              disabled={editButton === false ? true : false}
                              required="required"
                              showBottom={true}
                              error={errors.area}
                              inputClassName={classnames(
                                "input-component-inputfield",
                                {
                                  invalid: errors.area,
                                }
                              )}
                            />
                          </div>
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            {/* <NewInputText
                              displayLabel={true}
                              controlId="city"
                              labelText="City*"
                              placeHolder="eg. Pune*"
                              name="city"
                              inputType="text"
                              onChange={this.onChange}
                              onFocusOut={this.onFocusOut}
                              onKeyDown={InputCharacterCheck}
                              value={this.state.city}
                              disabled={editButton === false ? true : false}
                              required="required"
                              showBottom={true}
                              error={errors.city}
                              inputClassName={classnames(
                                "input-component-inputfield",
                                {
                                  invalid: errors.city,
                                }
                              )}
                            /> */}
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Country">
                                city*
                              </InputLabel>

                              <Select
                                value={this.state.data.city}
                                //value="101"
                                onChange={this.onChangeCityValue}
                                className="mb-4"
                                onBlur={this.onFocusOut}
                                label="cities"
                                inputProps={{
                                  name: "city",
                                  id: "outlined-cities",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                                error={errors.city}
                              >
                                {this.state.cities.map((city, index) => (
                                  <option key={index} value={city.id}>
                                    {city.name}
                                  </option>
                                ))}
                              </Select>
                              {errors.city && (
                                <div className="pho_14_regular text-danger">
                                  {errors.city}
                                </div>
                              )}
                            </FormControl>
                          </div>
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <NewInputText
                              displayLabel={true}
                              controlId="pinCode"
                              labelText="Pin/Zip Code*"
                              placeHolder="eg. 404040*"
                              name="pinCode"
                              inputType="text"
                              maxLength="10"
                              onChange={this.onChangePinCode}
                              onFocusOut={this.onFocusOut}
                              onKeyDown={InputCharNumFunc}
                              value={this.state.pinCode}
                              disabled={editButton === false ? true : false}
                              // onKeyDown={InputNumberFunc}
                              required="required"
                              showBottom={true}
                              error={errors.pinCode}
                              inputClassName={classnames(
                                "input-component-inputfield",
                                {
                                  invalid: errors.pinCode,
                                }
                              )}
                            />
                          </div>
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            {/* <NewInputText
                              displayLabel={true}
                              extraClass="mb-4"
                              controlId="businessState"
                              labelText="State*"
                              placeHolder="eg. Pune*"
                              name="businessState"
                              inputType="text"
                              onChange={this.onChange}
                              onFocusOut={this.onFocusOut}
                              onKeyDown={InputCharacterCheck}
                              value={this.state.businessState}
                              disabled={editButton === false ? true : false}
                              required="required"
                              showBottom={true}
                              error={errors.businessState}
                              inputClassName={classnames(
                                "input-component-inputfield",
                                {
                                  invalid: errors.businessState,
                                }
                              )}
                            /> */}

                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Country">
                                State*
                              </InputLabel>

                              <Select
                                value={this.state.data.state}
                                //value="101"
                                className="mb-4"
                                onChange={this.onChangeStateValue}
                                onBlur={this.onFocusOut}
                                error={errors.state}
                                label="states"
                                inputProps={{
                                  name: "state",
                                  id: "outlined-states",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {this.state.states.map((states, index) => (
                                  <option key={index} value={states.id}>
                                    {states.name}
                                  </option>
                                ))}
                              </Select>
                              {errors.state && (
                                <div className="pho_14_regular text-danger">
                                  {errors.state}
                                </div>
                              )}
                            </FormControl>
                          </div>
                        </div>
                      </div>
                      {/* <Form.Label className="col-12 p-0 restaurant_details_onboarding_mobile_number mt-4">
                        Enquiry Email
                      </Form.Label> */}
                      {this.state.enquiry_email.map((email, index) => (
                        <div
                          className="row align-items-center mb-4"
                          key={index}
                        >
                          <div className="col-9">
                            <NewInputText
                              displayLabel={false}
                              controlId="enquiry_email"
                              extraClass=" mb-2 "
                              labelText="Enquiry Email*"
                              placeHolder="eg. Vendor@restaurant.in*"
                              name="enquiry_email"
                              inputType="email"
                              onFocusOut={this.onFocusOut}
                              onChange={this.onEmailChangeHandler(index)}
                              value={email}
                              disabled={editButton === false ? true : false}
                              required="required"
                              error={
                                !validEmailRegex.test(email) && !isEmpty(email)
                                  ? "Please enter a valid email"
                                  : ""
                                // enquiry_email.length <= 0 ? errors.email : ''
                                // ||
                                //   (!validEmailRegex.test(email) &&
                                //   !isEmpty(email)
                                //     ? ''
                                //     : 'Please enter a valid email')
                              }
                              inputClassName={classnames(
                                "input-component-inputfield",
                                {
                                  invalid: errors.enquiry_email,
                                }
                              )}
                            />
                            <Form.Text className="text-muted input-component-bottom position-absolute">
                              <div className="text-danger text-capitalize">
                                {email === "" && this.state.errors.enquiry_email
                                  ? "Email is required"
                                  : null}
                              </div>
                            </Form.Text>
                          </div>
                          {/* {this.state.enquiry_email.length > 1 ? (
                            <div className="col-3 restaurant_details_onboarding_minus_button">
                              <div
                                className="restaurant_details_onboarding_minus_button_box"
                                onClick={this.onEmailDeleteHandler(index)}
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            </div>
                          ) : null} */}
                          <div className="col-3 restaurant_details_onboarding_minus_button">
                            {this.state.enquiry_email.length > 1 ? (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Delete"
                                  onClick={this.onEmailDeleteHandler(index)}
                                  fontIcon="fa fa-trash-o"
                                  colorCss="delete"
                                />
                              </div>
                            ) : (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Add Another"
                                  onClick={this.onEmailAddHandler}
                                  fontIcon="fa fa-plus"
                                  colorCss="blue"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {this.state.enquiry_email.length > 1 ? (
                        <div className="pl-0 restaurant_details_onboarding_minus_button">
                          <div onClick={this.onEmailAddHandler}>
                            <AddButtonIconComponent
                              buttonText="Add Another"
                              // onClick={this.onOpenModal}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </div>
                        </div>
                      ) : null}
                      {/* <Form.Label className="col-12 mt-3 pl-0 restaurant_details_onboarding_mobile_number">
                        Mobile Number
                      </Form.Label> */}
                      {this.state.contact_detail.map((phone, index) => (
                        <div
                          className="row align-items-center mb-4"
                          key={index}
                        >
                          <div className="col-4 col-xl-3">
                            <Form.Group
                              className="reusableInputComponent-main mb-0"
                              controlId={"country_code"}
                            >
                              <div className="input-phone-country-code-reusable">
                                <select
                                  name="country_code"
                                  value={phone?.country_code}
                                  onChange={this.onCountryCodeChangeHandler(
                                    index
                                  )}
                                >
                                  <option
                                    value={
                                      phone.country_code === ""
                                        ? this.state.country_code
                                        : phone.country_code
                                    }
                                  >
                                    {phone.country_code === ""
                                      ? this.state.country_code
                                      : phone.country_code}
                                  </option>
                                  {getCountries().map((country) => (
                                    <option
                                      key={country}
                                      value={
                                        "+" + getCountryCallingCode(country)
                                      }
                                      onClick={this.onChangeCountry}
                                    >
                                      {en[country]} (+
                                      {getCountryCallingCode(country)})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </Form.Group>
                          </div>
                          <div className="col-5 col-xl-6 pl-0">
                            <NewInputText
                              displayLabel={false}
                              controlId="mobile_no"
                              placeHolder="eg. 9898989898*"
                              labelText="Phone Number"
                              name="mobile_no"
                              extraClass="mb-0"
                              inputType="number"
                              onChange={this.onPhoneChangeHandler(index)}
                              onFocusOut={this.onFocusOut}
                              maxLength="10"
                              value={phone?.mobile_no}
                              disabled={editButton === false ? true : false}
                              onKeyDown={InputNumberFunc}
                              required="required"
                              // error={errors.mobileNumber}
                              error={
                                phone?.mobile_no?.length > 0 &&
                                phone?.mobile_no?.length <= 9
                                  ? "Enter valid Mobile Number"
                                  : ""
                              }
                              inputClassName={classnames(
                                "input-component-inputfield",
                                {
                                  invalid: errors.contact_detail,
                                }
                              )}
                            />
                            <Form.Text className="text-muted input-component-bottom position-absolute">
                              <div className="text-danger text-capitalize">
                                {/* {phone.mobile_no === ''
                                  ? this.state.phoneError.mobile_no
                                  : null} */}
                                {phone.mobile_no === "" &&
                                this.state.errors.mobile_no
                                  ? "Phone is required"
                                  : null}
                              </div>
                            </Form.Text>
                          </div>
                          <div className="col-3 restaurant_details_onboarding_minus_button">
                            {this.state.contact_detail.length > 1 ? (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Delete"
                                  onClick={this.onPhoneDeleteHandler(index)}
                                  fontIcon="fa fa-trash-o"
                                  colorCss="delete"
                                />
                              </div>
                            ) : (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Add Another"
                                  onClick={this.onPhondeAddHandler}
                                  fontIcon="fa fa-plus"
                                  colorCss="blue"
                                />
                              </div>
                            )}
                          </div>
                          {/* {this.state.contact_detail.length > 1 ? (
                            <div className="col-2 restaurant_details_onboarding_minus_button">
                              <div
                                className="restaurant_details_onboarding_minus_button_box"
                                onClick={this.onPhoneDeleteHandler(index)}
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            </div>
                          ) : null} */}
                        </div>
                      ))}
                      {/* <div className=" pl-0 restaurant_details_onboarding_minus_button mt-4">
                        <div onClick={this.onPhondeAddHandler}>
                          <AddButtonIconComponent
                            buttonText="Add Another"
                            // onClick={this.onOpenModal}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                      </div> */}
                      {this.state.contact_detail.length > 1 ? (
                        <div className="col-12 pl-0 restaurant_details_onboarding_minus_button add_email_button mt-0">
                          <div>
                            <AddButtonIconComponent
                              buttonText="Add Another Phone Number"
                              onClick={this.onPhondeAddHandler}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </div>
                        </div>
                      ) : null}
                      <div className="row restaurant_details_onboarding_country_box mb-md-3 mb-lg-3 mb-xl-3">
                        {/* <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 restaurant_details_onboarding_country_boxone">
                          <h4>Country</h4>
                        </div> */}
                        <div className="col-12 restaurant_details_onboarding_country_boxtwo mb-0">
                          <div
                          // className="restaurant_select_country"
                          >
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Country">
                                Country*
                              </InputLabel>

                              <Select
                                value={this.state.data.country}
                                //value="101"
                                onChange={this.onChangeCountryValue}
                                onBlur={this.onFocusOut}
                                error={errors.country}
                                label="country"
                                inputProps={{
                                  name: "country",
                                  id: "outlined-country",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {this.state.countries.map((country, index) => (
                                  <option key={index} value={country.id}>
                                    {country.name}
                                  </option>
                                ))}
                              </Select>
                              {errors.country && (
                                <div className="pho_14_regular text-danger">
                                  {errors.country}
                                </div>
                              )}
                            </FormControl>
                            {/* <select
                              name="country"
                              value={this.state.country}
                              onChange={this.onChange}
                              disabled={editButton === false ? true : false}
                              className="inside_select-box border-0"
                            >
                              <option value={this.state.country}>
                                {this.state.country}
                              </option>
                              {getCountries().map((country) => (
                                <option
                                  key={country}
                                  value={en[country]}
                                  //value={country + "  " + "(" + en[country] + ")"}
                                >
                                  {en[country]}
                                </option>
                              ))}
                            </select> */}
                            <Form.Text className="text-muted input-component-bottom">
                              {errors ? (
                                <div className="text-danger text-capitalize">
                                  {errors.country}
                                </div>
                              ) : null}
                            </Form.Text>
                          </div>
                        </div>
                        {/* <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 restaurant_details_onboarding_country_boxone">
                          <h4>Currency</h4>
                        </div> */}
                        <div className="col-12 mt-4 restaurant_details_onboarding_country_boxtwo mb-0">
                          <div className="">
                            <CurrencyPicker
                              value={this.state.currency}
                              name={"currency"}
                              onChange={this.onChange}
                              className="inside_select-box border-0"
                              disabled={editButton === false ? true : false}
                            />
                            <Form.Text className="text-muted input-component-bottom">
                              {errors ? (
                                <div className="text-danger text-capitalize">
                                  {errors.currency}
                                </div>
                              ) : null}
                            </Form.Text>
                          </div>
                        </div>
                        {/* <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 restaurant_details_onboarding_country_boxone">
                          <h4>Time Zone</h4>
                        </div> */}
                        <div className="col-12 mt-4 restaurant_details_onboarding_country_boxtwo">
                          <div className="">
                            <TimeZoneCustom
                              value={this.state.timezone}
                              name={"timezone"}
                              onChange={this.onChange}
                              className="inside_select-box border-0"
                              disabled={editButton === false ? true : false}
                            />
                            <Form.Text className="text-muted input-component-bottom">
                              {errors ? (
                                <div className="text-danger text-capitalize">
                                  {errors.timezone}
                                </div>
                              ) : null}
                            </Form.Text>
                          </div>
                        </div>
                      </div>
                      {this.state.showMore ? (
                        <>
                          <div
                            className="f13-500"
                            style={{ color: "#EE3A23", cursor: "pointer" }}
                            onClick={() => {
                              this.setState({ showMore: false });
                            }}
                          >
                            See less details{" "}
                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                          </div>
                          <div className="row">
                            <div className="col-12 mb-md-5 location-detections-popup-main">
                              <div className="location-detections-popup-bodyBox">
                                <h5 className="col-12 p-0 d-flex location-detections-popup-headingfive pt-3">
                                  Place ID:{" "}
                                  <p className="location-detections-popup-paragraphfive">
                                    {google_place_id}
                                  </p>
                                </h5>
                                <div className="d-flex justify-content-between">
                                  <div>
                                    <h5 className="location-detections-popup-headingfive">
                                      Lattitude
                                    </h5>
                                    <div className="location-detection-input-box">
                                      <h5 className="location-detections-popup-headingfive-input">
                                        {this.state.location.coordinates[0] ===
                                        ""
                                          ? ""
                                          : parseFloat(
                                              this.state.location.coordinates[0]
                                            ).toFixed(5)}
                                      </h5>
                                    </div>
                                  </div>
                                  <div>
                                    <h5 className="location-detections-popup-headingfive">
                                      Longitude
                                    </h5>
                                    <div className="location-detection-input-box">
                                      <h5 className="location-detections-popup-headingfive-input">
                                        {this.state.location.coordinates[1] ===
                                        ""
                                          ? ""
                                          : parseFloat(
                                              this.state.location.coordinates[1]
                                            ).toFixed(5)}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            style={{ color: "#EE3A23", cursor: "pointer" }}
                            className="f13-500 mb-4 pb-4"
                            onClick={() => {
                              this.setState({ showMore: true });
                            }}
                          >
                            See more details{" "}
                            <i
                              class="fa fa-chevron-down"
                              aria-hidden="true"
                            ></i>
                          </div>
                        </>
                      )}
                      <div
                        className="onboarding-map-setup-screen-autodetect-button justify-content-between"
                        style={{ marginBottom: "30px" }}
                      >
                        {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                        <ReusableOnboardingLink
                          buttonTitle="Cancel Button"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Cancel"
                          link="/profile"
                        />
                        {editButton === true ? (
                          <ReusableOnboardingButton
                            buttonTitle="Save Button"
                            buttonText="Save"
                            onClick={
                              changesText === false
                                ? () => {}
                                : this.onChangeScreen
                            }
                            buttonClass={
                              name === "" ||
                              address === "" ||
                              area === "" ||
                              city === "" ||
                              pinCode === "" ||
                              businessState === "" ||
                              country === "" ||
                              currency === "" ||
                              timezone === "" ||
                              enquiry_email[0] === "" ||
                              contact_detail[0].mobile_no === "" ||
                              contact_detail[0].mobile_no.length <= 9 ||
                              contact_detail[contact_detail.length - 1]
                                .mobile_no === "" ||
                              contact_detail[contact_detail.length - 1]
                                .mobile_no.length <= 9 ||
                              enquiry_email[enquiry_email.length - 1] === "" ||
                              !validEmailRegex.test(enquiry_email[0]) ||
                              changesText === false
                                ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                            }
                            disabled={
                              name === "" ||
                              address === "" ||
                              area === "" ||
                              city === "" ||
                              pinCode === "" ||
                              businessState === "" ||
                              country === "" ||
                              currency === "" ||
                              timezone === "" ||
                              enquiry_email[0] === "" ||
                              contact_detail[0].mobile_no === "" ||
                              contact_detail[0].mobile_no.length <= 9 ||
                              contact_detail[contact_detail.length - 1]
                                .mobile_no === "" ||
                              contact_detail[contact_detail.length - 1]
                                .mobile_no.length <= 9 ||
                              enquiry_email[enquiry_email.length - 1] === "" ||
                              !validEmailRegex.test(enquiry_email[0]) ||
                              changesText === false
                                ? true
                                : false
                            }
                          />
                        ) : null}
                        {/* </div> */}
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorRestaurantDetailsEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getAllCountries: PropTypes.func.isRequired,
  getAllStateFromCountry: PropTypes.func.isRequired,
  getAllCityFromState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
  getAllStateFromCountry,
  getAllCityFromState,
  getAllCountries,
})(withRouter(VendorRestaurantDetailsEdit));
